import React from 'react'
import Hero from './Hero/Hero'
import Recruitment from './Recruitment/Recruitment'
import SmartResume from './SmartResume/SmartResume'
import Features from './Features/Features'
import WhyResume from './WhyResume/WhyResume'
import Benefit from './Benefit/Benefit'
import IntegrationSection from './IntegrationSection/IntegrationSection'
import TestimonialSection from './TestimonialSection/TestimonialSection'
import FAQSection from './FAQSection/FAQSection'
import PricingSection from './PricingSection/PricingSection'
import ScrenningResume from './ScrenningResume/ScrenningResume'

function ResumeScreen() {
  return (
    <div>
      <Hero />
      <Recruitment />
      <SmartResume />
      <Features />
      <WhyResume />
      <Benefit />
      <IntegrationSection />
      <TestimonialSection />
      <FAQSection />
      <PricingSection />
      <ScrenningResume />
    </div>
  )
}

export default ResumeScreen
